export default __webpack_public_path__ + "static/media/support-notes-logo-iproup.6c2930a5.svg";